class Core {
    constructor() {
        this.currentTimeout = null;
    };
    wait(timeout) {
        if (this.currentTimeout) {
            clearTimeout(this.currentTimeout);
        };
        return new Promise(resolve => {
            this.currentTimeout = setTimeout(resolve, timeout);
        });
    };
};
window.addEventListener("load", function () {
    const dndPromotion = window.libraryMainsite.promotion;

    // Quét ánh sáng qua từng nhân vật (.effect)
    function playEffect() {
        var effect = document.querySelector('#frame1 .effect');
        if (!effect) return;

        // reset để animation chạy lại từ đầu mỗi lần gọi
        effect.classList.remove('is-active');
        void effect.offsetWidth; // force reflow
        effect.classList.add('is-active');

        setTimeout(function () {
            effect.classList.remove('is-active');
        }, 2000);
    };

    async function animationRandom() {
        playEffect();
    };

    dndPromotion({
        url: prodTemplate.url,
        debug: prodTemplate.debug,
        directory: prodTemplate.directory,
        items: prodTemplate.items,
        names: prodTemplate.names,
        config: {
            timeWait: 2100,
        },
        animResult: function (listPrize) {
            var displayPrize = listPrize[0];
            var prizeIndex = displayPrize.indexImg;
            animationRandom();
        },
        callback: function () {
            if (typeof prodTemplate.fnPromotion === "function") prodTemplate.fnPromotion();
            // globalCount = 10;

        },
    })  

    
});


(function () {
  // Paging cho list-moc trên mobile: trang 1 -> cuộn về đầu, trang 2 -> cuộn về cuối
  var listMoc = document.querySelector('#frame1 .list-moc');
  var pagingDots = document.querySelectorAll('#frame1 .moc-paging .paging');

  pagingDots.forEach(function (dot) {
    dot.addEventListener('click', function (e) {
      e.preventDefault();
      if (!listMoc) return;

      var toEnd = dot.getAttribute('data-scroll') === 'end';
      listMoc.scrollTo({
        left: toEnd ? listMoc.scrollWidth : 0,
        behavior: 'smooth',
      });

      pagingDots.forEach(function (d) {
        d.classList.remove('is-active');
      });
      dot.classList.add('is-active');
    });
  });
})();
